// SPDX-License-Identifier: AGPL-3.0-or-later

import {ChannelSourcePreview} from '@app/features/channel/components/ChannelSourcePreview';
import type {Channel} from '@app/features/channel/models/Channel';
import styles from '@app/features/messaging/components/popouts/InboxMessageHeader.module.css';
import type {MediaProxyImageSize} from '@app/vendor/constants/MediaProxyImageSizes';
import {observer} from 'mobx-react-lite';
import type React from 'react';

interface InboxMessageHeaderProps {
	channel: Channel;
	onClick?: () => void;
	leftAdornment?: React.ReactNode;
	rightActions?: React.ReactNode;
	mentionCount?: number;
	avatarSize?: MediaProxyImageSize;
}
export const InboxMessageHeader = observer(function InboxMessageHeader({
	channel,
	onClick,
	leftAdornment,
	rightActions,
	mentionCount,
	avatarSize = 32,
}: InboxMessageHeaderProps) {
	return (
		<div className={styles.header}>
			<div className={styles.headerLeft}>
				{leftAdornment}
				<ChannelSourcePreview channel={channel} onClick={onClick} mentionCount={mentionCount} avatarSize={avatarSize} />
			</div>
			{rightActions && <div className={styles.headerActions}>{rightActions}</div>}
		</div>
	);
});
